var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "farmingon",
            "title": "Solution",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" Smart Farm Solution ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v("You can easily install this user-friendly FarmingON in your desired location. "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("You can monitor the data collected from the growth environment of crops in real time via the mobile app and web browser.")];
      },
      proxy: true
    }])
  }, [_c('b', [_vm._v("FarmingON Series")]), _vm._v(" "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("that measures the growth environment "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("of crops as the foundation for data agriculture ")]), _c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "432",
      "aspect-ratio": 432 / 596,
      "src": "/images/sub/solution/smartfarm/farmingon-img.png",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  })], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', {
    attrs: {
      "id": "farmingon1"
    }
  }, [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "mx-n20px my-n10px mx-md-n30px my-md-n20px"
        }, [_c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 570 / 456,
            "content-class": "d-flex pa-20px"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "256",
            "aspect-ratio": 256 / 288,
            "src": "/images/sub/solution/smartfarm/farmingon-img2.png"
          }
        })], 1)], 1)], 1), _c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-right",
            "data-aos-delay": "200"
          }
        }, [_c('div', {
          staticClass: "mt-md-24px"
        }, [_c('tit-wrap-sprout', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Real-time greenhouse crop growth environment monitoring system ")];
            },
            proxy: true
          }])
        }, [_vm._v(" FarmingON ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Measurement items")];
            },
            proxy: true
          }])
        }, [_vm._v(" Temperature, humidity, CO2, and soil temperature ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Applications")];
            },
            proxy: true
          }])
        }, [_vm._v(" Greenhouse crops such as bell peppers, cucumbers, tomatoes, and strawberries ")])], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 770,
            "content-class": "d-flex align-center justify-center"
          }
        }, [_c('div', {
          staticClass: "pa-30px pa-md-40px px-lg-80px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "800",
            "width": _vm.$vuetify.breakpoint.lgAndUp ? '800' : '',
            "aspect-ratio": 800 / 376,
            "src": "/images/sub/solution/smartfarm/farmingon-img3.png"
          }
        }), _c('div', {
          staticClass: "pt-30px pt-md-40px pt-lg-60px"
        }, [_c('tit-wrap-small', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v("This IoT system lets you monitor crop growth environment data remotely via the Internet or mobile device.")];
            },
            proxy: true
          }])
        }, [_vm._v(" Easy and simple real-time monitoring via both the Internet and mobile device ")])], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/farmingon-img4.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Growth Environment Measurement Device ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Registered Patent ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('page-section', {
    staticClass: "grey lighten-5",
    attrs: {
      "id": "farmingon2"
    }
  }, [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "mx-n20px my-n10px mx-md-n30px my-md-n20px"
        }, [_c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 570 / 456,
            "content-class": "d-flex pa-20px"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "448",
            "aspect-ratio": 448 / 208,
            "src": "/images/sub/solution/smartfarm/farmingon-img5.png"
          }
        })], 1)], 1)], 1), _c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-right",
            "data-aos-delay": "200"
          }
        }, [_c('div', {
          staticClass: "mt-md-24px"
        }, [_c('tit-wrap-sprout', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Monitors the growth environment and root zones of greenhouse crops in real time ")];
            },
            proxy: true
          }])
        }, [_vm._v(" FarmingON2 ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Measurement items of the main body")];
            },
            proxy: true
          }])
        }, [_vm._v(" Temperature, humidity, CO2, root zone measurement, and drainage pH ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px letter-spacing-n02"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Measurement items of probe sensors")];
            },
            proxy: true
          }])
        }, [_vm._v(" Medium temperature, medium humidity, and medium EC ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Applications")];
            },
            proxy: true
          }])
        }, [_vm._v(" Greenhouse crops such as bell peppers, cucumbers, tomatoes, and strawberries ")])], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": "",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 770,
            "content-class": "d-flex align-center justify-center"
          }
        }, [_c('div', {
          staticClass: "pa-30px pa-md-40px px-lg-80px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "800",
            "width": _vm.$vuetify.breakpoint.lgAndUp ? '800' : '',
            "aspect-ratio": 800 / 376,
            "src": "/images/sub/solution/smartfarm/farmingon-img6.png"
          }
        }), _c('div', {
          staticClass: "pt-30px pt-md-40px pt-lg-60px"
        }, [_c('tit-wrap-small', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v("This IoT cultivation environment monitoring system helps you understand the growth environment and root zones of greenhouse crops at a glance. greenhouse crop growth environment and root zones.")];
            },
            proxy: true
          }])
        }, [_vm._v(" Easy and simple real-time monitoring via both the Internet and mobile device ")])], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/farmingon-img7.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Method and Apparatus for Measuring the State of Medium in Nutriculture ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Registered Patent ")])], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/farmingon-img8.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Medium Measurement Device ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Registered in the Agricultural Machinery List ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "id": "farmingon-portfolio"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(" Portfolio ")];
      },
      proxy: true
    }, {
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mx-auto px-12px",
          staticStyle: {
            "max-width": "1480px"
          }
        }, [_c('v-tabs-items', {
          attrs: {
            "touchless": ""
          },
          model: {
            value: _vm.tab,
            callback: function callback($$v) {
              _vm.tab = $$v;
            },
            expression: "tab"
          }
        }, [_c('v-tab-item', {
          attrs: {
            "transition": "fade-transition",
            "reverse-transition": "fade-transition"
          }
        }, [_c('farmingon1-slide')], 1), _c('v-tab-item', {
          attrs: {
            "transition": "fade-transition",
            "reverse-transition": "fade-transition"
          }
        }, [_c('farmingon2-slide')], 1)], 1)], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "tabs-wrap"
  }, [_c('v-tabs', {
    staticClass: "v-tabs--btn",
    attrs: {
      "hide-slider": "",
      "show-arrows": "",
      "centered": "",
      "center-active": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('u-tab', [_vm._v("FarmingON")]), _c('u-tab', [_vm._v("FarmingON2")])], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }